// This icon file is generated automatically.
var PPlusSquareOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M4.13 7.5H6.5v2.38c0 .06.06.12.13.12h.75c.06 0 .12-.06.12-.13V7.5h2.38c.06 0 .12-.06.12-.13v-.75a.13.13 0 00-.13-.12H7.5V4.12A.13.13 0 007.37 4h-.75a.13.13 0 00-.12.13V6.5H4.12a.13.13 0 00-.12.13v.75c0 .06.06.12.13.12z" } }, { "tag": "path", "attrs": { "d": "M12.75.75H1.25a.5.5 0 00-.5.5v11.5c0 .28.22.5.5.5h11.5a.5.5 0 00.5-.5V1.25a.5.5 0 00-.5-.5zm-.63 11.38H1.88V1.87h10.25v10.25z" } }] }] }, "name": "p-plus-square", "theme": "outlined" };
export default PPlusSquareOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PPlusSquareOutlined.js
// module id = 3544
// module chunks = 0